import { Casa, Estudios, Herencia, Impuestos, Invertir, Jubilacion } from '../scenes/Help/articles';

export const help = [
  {
    title: 'Comprar una casa',
    text: 'Una de las mayores decisiones que tomamos a lo largo de nuestra vida.',
    path: '/asesores/ayuda/comprar-una-casa',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Casa
  },
  {
    title: 'Ahorrar para los estudios',
    text: 'Una preocupación habitual en las familias es asegurar la educación de sus hijos.',
    path: '/asesores/ayuda/ahorrar-para-los-estudios',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Estudios
  },
  {
    title: 'Pagar menos impuestos',
    text: 'Sin ayuda, puede que acabemos pagando más de lo que deberíamos.',
    path: '/asesores/ayuda/pagar-menos-impuestos',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Impuestos
  },
  {
    title: 'Preparar tu jubilación',
    text: 'Para que puedas mantener tu nivel de vida, cuando dejes de trabajar.',
    path: '/asesores/ayuda/preparar-tu-jubilacion',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Jubilacion
  },
  {
    title: 'Herencia e ingresos extra',
    text: 'Recibes un dinero inesperado y no sabes por dónde empezar.',
    path: '/asesores/ayuda/herencia-ingresos-extra',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Herencia
  },
  {
    title: 'Invertir tus ahorros',
    text: 'Elegir los fondos y acciones correctos es clave para rentabilizar nuestro dinero.',
    path: '/asesores/ayuda/invertir-ahorros',
    exact: true,
    params: {},
    components: [],
    identifiers: [],
    component: Invertir
  }
];
